<template>
<div class="csKp">
  <p>姓名：{{gk.CustomerName}}</p>
  <p>性别：{{gk.CustomerGender == 1 ? '男' : '女'}}</p>
  <p>年龄：{{gk.CustomerAge}}</p>
  <p>生日：{{gk.CustomerBirthday}}</p>
  <p>电话：{{gk.CustomerTel}}</p>
  <p style="margin-bottom: 20px;">来源：{{gk.CustomerRegSource}}</p>

  <el-button type="danger" @click="gbss">关闭</el-button>
</div>
</template>

<script>
export default {
  name: "csKp",
  data() {
    return {
      gk: {}
    }
  },
  created() {
    this.gk = this.$store.state.users.CsUser
  },
  methods: {
    gbss() {
      this.$emit('gb', false)
    }
  }
}
</script>

<style scoped lang="scss">
.csKp {
  position: absolute;
  top: 20px;
  z-index: 9999999;
  background: #FFFFFF;
  width: 200px;
  height: 200px;
  border-radius: 10px;
  padding: 20px;
  box-shadow:
      0 1px 2px rgba(0,0,0,0.07),
      0 2px 4px rgba(0,0,0,0.07),
      0 4px 8px rgba(0,0,0,0.07),
      0 8px 16px rgba(0,0,0,0.07),
      0 16px 32px rgba(0,0,0,0.07),
      0 32px 64px rgba(0,0,0,0.07);
  p {text-align: left;}
}
</style>
